import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { ClientSessionsPanel } from "@/components/client/ClientSessionsPanel";

export const Route = createFileRoute("/dashboard/client/sessions")({
  component: ClientSessions,
});

function ClientSessions() {
  const { t } = useTranslation();

  return (
    <div className="mx-auto max-w-4xl space-y-8">
      <div>
        <h1
          className="text-2xl font-bold text-foreground"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          {t("client.sessions.title")}
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {t("client.sessions.subtitle")}
        </p>
      </div>

      <ClientSessionsPanel />
    </div>
  );
}
